import { ElementType } from 'react';
import CustomTooltip from 'Components/Form/CustomTooltip/CustomTooltip';
import { Input } from 'antd';
import styles from './CustomInput.module.scss';

const CustomInput = ({
  field,
  fieldName,
  labelName,
  placeholder = '',
  suffix: Suffix,
  error = {},
  type = 'text',
  autoComplete = 'on',
}: {
  field: any;
  fieldName: string;
  labelName?: string;
  placeholder?: string;
  suffix?: ElementType;
  error?: any;
  type?: 'tel' | 'text' | 'email';
  autoComplete?: 'on' | 'off';
}) => {
  return (
    <>
      {labelName && <label htmlFor={fieldName}>{labelName}</label>}
      <CustomTooltip error={error}>
        <Input
          id={fieldName}
          name={fieldName}
          type={type}
          className={styles.input}
          allowClear
          suffix={Suffix ? <Suffix className={styles.input__icon} /> : ''}
          placeholder={placeholder}
          status={error.message ? 'warning' : ''}
          autoComplete={autoComplete}
          {...field}
        />
      </CustomTooltip>
    </>
  );
};

export default CustomInput;
